import {EventApi} from '@fullcalendar/core';
import moment from 'moment/moment';

import {sum} from '_/utilities';

export function toSeconds(minutes: number): number {
  return minutes * 60;
}

export function toMinutes(seconds: number): number {
  return seconds / 60;
}

export function getEventDurationInHours(date: EventApi): number {
  return getEventDuration(date, 'hours');
}

export function getEventDuration(
  date: EventApi,
  unit: moment.unitOfTime.Diff
): number {
  const start = moment(date.start);
  const end = moment(date.end);

  return end.diff(start, unit, true);
}

export function getTotalEventDurationInHours(dates: EventApi[]): number {
  return dates.map(getEventDurationInHours).reduce(sum, 0);
}
